<template>
  <SiteChrome>
    <BlogArticleView
      v-if="item"
      :item="item"
    >
      <template #after-content>
        <BlogCommentSection
          :slug="item.slug"
          :comments-enabled="item.commentsEnabled"
          :require-login="item.requireLogin"
          :comments-closed="item.commentsClosed"
        />
      </template>
      <template #sidebar>
        <div
          v-if="related.length"
          class="space-y-3"
        >
          <p class="text-sm font-semibold">
            مقالات مرتبط
          </p>
          <BlogArticleCard
            v-for="post in related"
            :key="post.id"
            :post="post"
          />
        </div>
      </template>
    </BlogArticleView>
    <div
      v-else
      class="flex min-h-[50vh] items-center justify-center"
    >
      <p class="text-[var(--ui-text-muted)]">
        مقاله یافت نشد.
      </p>
    </div>
  </SiteChrome>
</template>

<script setup lang="ts">
import type { BlogPostListItem, BlogPostPublic } from '~/types/blog'

const route = useRoute()
const slug = computed(() => String(route.params.slug))

const { data } = await useFetch<{ item: BlogPostPublic; related: BlogPostListItem[] }>(
  () => `/api/blog/posts/${encodeURIComponent(slug.value)}`,
)
const item = computed(() => data.value?.item ?? null)
const related = computed(() => data.value?.related ?? [])

const seo = useSiteSeo({
  title: item.value?.seoTitle || item.value?.title || 'مقاله',
  description: item.value?.seoDescription || item.value?.excerpt || '',
  image: item.value?.coverUrl || undefined,
  keywords: item.value?.tags ?? [],
  noindex: !!item.value?.noindex,
  type: 'article',
})

useHead(() => {
  if (!item.value) return {}
  return {
    script: [{
      type: 'application/ld+json',
      innerHTML: JSON.stringify({
        '@context': 'https://schema.org',
        '@type': 'BlogPosting',
        mainEntityOfPage: seo.canonicalUrl.value,
        headline: item.value.title,
        description: item.value.seoDescription || item.value.excerpt,
        image: item.value.coverUrl || undefined,
        datePublished: item.value.publishedAt,
        dateModified: item.value.updatedAt,
        author: { '@type': 'Person', name: item.value.authorName },
        reviewedBy: item.value.reviewerName ? { '@type': 'Person', name: item.value.reviewerName } : undefined,
      }),
    }],
  }
})

onMounted(() => {
  if (item.value) {
    void $fetch(`/api/blog/posts/${encodeURIComponent(item.value.slug)}/view`, { method: 'POST' })
  }
})
</script>
